import React from "react";
import { useHistory } from "react-router-dom";

import Article from "@/components/molecules/Article";
import Footer from "@/components/molecules/Footer";
import Header from "@/components/molecules/Header";
import i18n from "@/translate/i18n";
import { LayoutWrapper } from "@/components/molecules/Wrappers/LayoutWrapper";
import ReturnButton from "@/components/atoms/Buttons/ReturnButton";

function PrivacyPolicy() {
  const history = useHistory();

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header />
        <LayoutWrapper className="px-8 pt-6 !items-start">
          <ReturnButton
            handleClick={history.goBack}
            title={i18n.t("header.return")}
          />
          <Article
            textContent={i18n.t("privacyPolicy.content", {
              returnObjects: true,
            })}
            textIndent={0}
            title={i18n.t("privacyPolicy.title")}
            titlePosition="left"
          />
        </LayoutWrapper>
        <Footer />
      </div>
    </div>
  );
}

export default PrivacyPolicy;
